<template>
  <h2 class="recent">Class Notice Board</h2>
  <div
    v-for="announcement in announcements"
    :key="announcement.id"
  >
    <SingleClassAnnouncement
      :announcement="announcement"
      @announcementdeleted="announcementDeletion"/>
  </div>
</template>

<script>
import SingleClassAnnouncement from './SingleClassAnnouncement.vue'
export default {
  components: { SingleClassAnnouncement },
  props: ['announcements'],
  emits: ['announcementdeletion'],
  setup (props, context) {
    const announcementDeletion = () => {
      context.emit('announcementdeletion')
    }
    return { announcementDeletion }
  }
}
</script>

<style>
  h2.recent {
      color: var(--inspire-rose);
      margin-top: 0;
      margin-bottom: 5px;
    }
</style>
